export default "__VITE_ASSET__DwOkuOTY__"